import { ICON_AIRPLANE, ICON_TRAVEL } from '@repo/assets';
import styled from 'styled-components';

const TEXT = {
  title: ['Have you departed\nfrom Korea?', '출국했습니까?'],
  yes: ['Yes,', '네,'],
  departed: ['I have departed', '출국했습니다'],
  no: ['No,', '아니오,'],
  notDeparted: ['not yet', '출국하지 않았습니다'],
};

type Props = {
  onYes?: () => void;
  onNo?: () => void;
  nationality?: string;
};

export const DepartureCheck = ({ onYes, onNo, nationality = 'ENG' }: Props) => {
  const nationIndex = nationality === 'KOR' ? 1 : 0;

  return (
    <>
      <Title>{TEXT.title[nationIndex]}</Title>
      <Wrapper>
        <Container onClick={onYes}>
          <TextWrapper>
            <Text>
              <p>{TEXT.yes[nationIndex]}</p>
              <p>{TEXT.departed[nationIndex]}</p>
            </Text>
          </TextWrapper>
          <AirplaneIcon src={ICON_AIRPLANE} alt='' />
        </Container>
        <Container onClick={onNo}>
          <TextWrapper>
            <Text>
              <p>{TEXT.no[nationIndex]}</p>
              <p>{TEXT.notDeparted[nationIndex]}</p>
            </Text>
          </TextWrapper>
          <TravelIcon src={ICON_TRAVEL} alt='' />
        </Container>
      </Wrapper>
    </>
  );
};

const Title = styled.h2`
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 24px;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
  letter-spacing: -0.48px;
  white-space: pre-line;
  text-align: left;
  width: 100%;
  margin-bottom: 24px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const Container = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 195px;
  padding: 15px 20px;
  border: 1px solid #cbccce;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(25, 25, 25, 0.18);
  cursor: pointer;
  text-align: left;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 122px;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.32px;
  color: #111111;
  white-space: pre;

  p {
    margin: 0;
  }
`;

const AirplaneIcon = styled.img`
  transform: rotate(-90deg);
  margin-left: auto;
`;

const TravelIcon = styled.img`
  height: 50px;
  margin-left: auto;
  margin-right: -5px;
`;

export default DepartureCheck;
